export const routes = [
    {
        path: 'user/email-validation/:token',
        loadComponent: () => import('@modules/authentication/core/password-renew/password-renew.component').then(m => m.PasswordRenewComponent),
    },
    {
        path: 'unauthorized',
        loadComponent: () => import('@modules/authentication/core/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
    },
    {
        path: 'forgot-password',
        loadComponent: () => import('@modules/authentication/core/forgot-password/forgot-password.component').then(m => m.FuseForgotPasswordComponent),
    },
    {
        path: 'forgot-password/:params',
        loadComponent: () => import('@modules/authentication/core/forgot-password/forgot-password.component').then(m => m.FuseForgotPasswordComponent),

    },
    {
        path: 'user/reset/:token',
        loadComponent: () => import('@modules/authentication/core/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),

    },
    {
        path: 'user/reset/:token/origin/:origin',
        loadComponent: () => import('@modules/authentication/core/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),

    },
    {
        path: 'password-reset-email',
        loadComponent: () => import('@modules/authentication/core/password-reset-email/password-reset-email.component').then(m => m.FusePasswordResetEmailComponent),
    }
];